module.exports = __webpack_public_path__ + "img/green-check.77c4b966.svg";